<template>
  <div class="hruseractivity w-100 biometric-shimmer-wrapper">
    <ul class="m-0 p-0 float-left w-100">
      <li
        v-for="i in 8"
        :key="i"
        class="biometric-shimmer-row"
      >
        <div class="d-flex justify-content-between align-items-center w-100">
          <!-- Description shimmer (left side — wide) -->
          <div class="biometric-shimmer-description">
            <skeleton-loader-vue
              type="ract"
              :width="shimmerWidths[i - 1]"
              :height="14"
              animation="wave"
            />
          </div>
          <!-- Timestamp shimmer (right side — short) -->
          <div class="biometric-shimmer-time">
            <skeleton-loader-vue
              type="ract"
              :width="70"
              :height="12"
              animation="wave"
            />
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import SkeletonLoaderVue from 'skeleton-loader-vue'

export default {
  name: 'BiometricShimmer',
  components: {
    SkeletonLoaderVue,
  },
  data() {
    return {
      // Vary widths so rows look natural, not robotically identical
      shimmerWidths: [260, 310, 240, 290, 320, 250, 300, 270],
    }
  },
}
</script>

<style scoped>
.biometric-shimmer-wrapper {
  padding: 4px 0;
}

.biometric-shimmer-row {
  list-style: none;
  padding: 10px 0;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  display: flex;
  align-items: center;
}

.biometric-shimmer-row:last-child {
  border-bottom: none;
}

.biometric-shimmer-description {
  flex: 1;
  padding-right: 16px;
}

.biometric-shimmer-time {
  flex-shrink: 0;
}
</style>
